export const EBestCreatorRankingType = {
  /**
   * 지난 6개월동안 월별 최고 순위
   */
  Monthly: 'monthly',
  /**
   * 지난 6개월동안 주별 최고 순위
   */
  Weekly: 'weekly',
  /**
   * 실시간 순위
   */
  Realtime: 'realtime',
} as const;

export type EBestCreatorRankingType = (typeof EBestCreatorRankingType)[keyof typeof EBestCreatorRankingType];
